export default __webpack_public_path__ + "25612eff09f0750775fc1fbb9d59dcb7.svg";